import {GitHubAvatar} from '@github-ui/github-avatar'
import {userHovercardPath} from '@github-ui/paths'
import {Box, Link} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import type {IssueBodyHeaderAuthor$key} from './__generated__/IssueBodyHeaderAuthor.graphql'

export function IssueBodyHeaderAuthor({author, showLogin}: {author: IssueBodyHeaderAuthor$key; showLogin?: boolean}) {
  const {login, avatarUrl} = useFragment(
    graphql`
      fragment IssueBodyHeaderAuthor on Actor {
        login
        avatarUrl
      }
    `,
    author,
  )

  return (
    <Box sx={{display: showLogin ? 'inline' : 'block'}}>
      <Link
        href={`/${login}`}
        data-hovercard-url={userHovercardPath({owner: login})}
        sx={{
          color: 'fg.default',
          fontWeight: 500,
        }}
      >
        {/* we should keep the size in sync with VALUES.timelineAvatarSize but for some reasons this breaks the storybook for the issue-viewer :/ */}
        {showLogin ? login : <GitHubAvatar src={avatarUrl} size={24} alt={`@${login}`} />}
      </Link>
    </Box>
  )
}

try{ IssueBodyHeaderAuthor.displayName ||= 'IssueBodyHeaderAuthor' } catch {}